import React from "react";

const SECTIONS = [
  {
    title: "Workspace Layout",
    bullets: [
      "Top toolbar: draw/erase tools, fractional toggle, fill, select, backstitch line mode, zoom, grid options, and export/save controls.",
      "Left sidebar: search manufacturer palettes, add colors to 'My Palette', and assign custom symbols.",
      "Design canvas: pan with the middle mouse button or space+drag, zoom with mouse wheel or the zoom buttons, and click to paint stitches."
    ],
  },
  {
    title: "Drawing & Editing",
    bullets: [
      "Use Draw/Erase for single stitches, Fill for contiguous areas, and Line to place straight backstitch segments.",
      "Fractional mode lets you click quadrants for quarter/half stitches; disable it to return to full stitches.",
      "Selection tool supports copy/cut/paste moves, and Find/Replace (Pro) swaps colors everywhere." 
    ],
  },
  {
    title: "Color Management",
    bullets: [
      "'My Palette' lists every color in your design. Click a swatch to make it active, or edit the symbol via the Symbols button.",
      "Use Analyze Colors (from Import) or Palette Optimization (Pro) to clean up unused shades.",
      "Hover a stitch to see its color/detail in the status panel (bottom of the sidebar)."
    ],
  },
  {
    title: "Images & Overlays",
    bullets: [
      "Import Image opens a modal with two paths: convert directly into stitches or place as a faint overlay guide.",
      "Overlay Settings (camera icon) let you reposition, scale, and fade reference images to trace over.",
      "Use the fractional detail switch during conversion for auto-generated quarter/half stitches." 
    ],
  },
  {
    title: "Saving & Exporting",
    bullets: [
      "'Save' writes a JSON design that can be reloaded later; 'Save As' prompts for a new filename.",
      "Export PNG+Key creates a high-resolution chart plus palette legend. Branding options control the header/logo.",
      "Menu > Quick Tour reopens this guide any time; Menu > Start New Design spins up a blank project."
    ],
  },
];

export default function TutorialModal({ onClose }) {
  return (
    <div className="modal-backdrop">
      <div className="modal" style={{ maxWidth: "720px" }}>
        <div className="modal-header">
          <h2>🚀 Quick Tour</h2>
          <button className="icon-btn" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <p className="hint">
            Welcome to Cross-Stitch Designer! Here’s a whirlwind primer on the features you’ll use most often.
          </p>
          {SECTIONS.map((section) => (
            <div className="setting-group" key={section.title}>
              <h3>{section.title}</h3>
              <ul style={{ paddingLeft: "1.5rem", margin: 0 }}>
                {section.bullets.map((line, idx) => (
                  <li key={idx} style={{ marginBottom: "0.35rem" }}>
                    {line}
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <p className="hint">
            Need more help? Reach out via the support link in the footer or join our community Discord from the Menu.
          </p>
        </div>
        <div className="modal-actions">
          <button className="btn btn-primary" onClick={onClose}>
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
}
